import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserAuth } from '../../context/AuthContext';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import TokenContext from '../../context/TokenContext';
import { actividadesHitos, limpiarActividades } from '../../Redux/asignacionesActividades';
import { COLUMNSHITOSACTIVIDADES } from '../../columnas/columnasAsignacionesActividades';
import TablaHitos from '../tablas/TablaHitos';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';

const ModalActividadesHitos = ({ open, handleClose, hitoId }) => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const { empleado } = UserAuth()

    //ACTIVIDADES HITOS
    const [hitosActividades, setHitosActividades] = React.useState([])
    const [loadingHitosActividades, setLoadingHitosActividades] = React.useState(false)
    const hitosActividadesSelector = useSelector(store => store.asignacionesActividades.hitosActividades)
    const getHITOSActividadesselector = useSelector(store => store.asignacionesActividades.getHitosActividades)

    React.useEffect(() => {
        if (token && empleado && hitoId) {
            dispatch(actividadesHitos(token, hitoId, empleado.usuarioPortalRh))
        }
    }, [token, empleado, hitoId])

    React.useEffect(() => {
        if (hitosActividadesSelector?.length > 0 && getHITOSActividadesselector === true) {
            var array = []
            hitosActividadesSelector.forEach(element => {
                var objeto = {
                    id: element.activityid,
                    new_cantidaddedias: element["new_cantidaddedias@OData.Community.Display.V1.FormattedValue"],
                    new_ordendentrodelhito: element["new_ordendentrodelhito@OData.Community.Display.V1.FormattedValue"],
                    scheduledend: element["scheduledend@OData.Community.Display.V1.FormattedValue"],
                    scheduledstart: element["scheduledstart@OData.Community.Display.V1.FormattedValue"],
                    subject: element.subject,
                    actualstart: element.actualstart,
                    actualend: element.actualend
                }
                array.push(objeto)
            });
            setHitosActividades(array)
            setLoadingHitosActividades(true)
        } else if (hitosActividadesSelector?.length == 0 && getHITOSActividadesselector === true) {
            setLoadingHitosActividades(true)
        }
    }, [hitosActividadesSelector, hitoId])

    const cerrarYlimpiar = () => {
        handleClose(false)
        setHitosActividades([])
        setLoadingHitosActividades(false)
        dispatch(limpiarActividades());
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={() => cerrarYlimpiar()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='xl'
            >
                <DialogTitle>Actividades del Hito</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {
                            !loadingHitosActividades ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            ) :
                                hitosActividades.length > 0 ? (
                                    <>
                                        <TablaHitos columnas={COLUMNSHITOSACTIVIDADES} lineas={hitosActividades} />
                                    </>
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        No existen registros de — <strong>Actividades del hito</strong>.
                                    </Alert>
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => cerrarYlimpiar()} color="secondary" variant="contained">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalActividadesHitos